import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const SharePage = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname === "/share") {
      window.open("/share");
    }
  }, [location]);

  return <></>;
};

export default SharePage;
